import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import RoleBasicInfoModel from "../../../../../viewModels/Role/RoleBasicInfoModel";
import { FormErrorModel } from "../../../../../viewModels/General/ErrorModel";
import { UserModel } from "../../../../../viewModels/User/UserModel";
import { BackOfficeProfileFormInputModel } from "./components/BackOfficeProfileForm";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  backOfficeProfile: UserModel;
  role: RoleBasicInfoModel;
  profileFormErrors: Array<FormErrorModel>;
} = {
  loading: true,
  loadingData: true,
  backOfficeProfile: undefined!,
  role: undefined!,
  profileFormErrors: undefined!,
};

const backOfficeProfilePageSlice = createSlice({
  name: "backOfficeProfile",
  initialState,
  reducers: {
    loadBackOfficeProfile(state) {
      state.loadingData = true;
    },
    loadBackOfficeProfileSuccess(state, action: PayloadAction<UserModel>) {
      state.loading = false;
      state.loadingData = false;
      state.backOfficeProfile = action.payload;
    },
    loadBackOfficeProfileError(state) {
      state.loading = false;
      state.loadingData = false;
    },

    updateBackOfficeProfile(state, _action: PayloadAction<BackOfficeProfileFormInputModel>) {
      state.loadingData = true;
    },
    updateBackOfficeProfileSuccess(state, action: PayloadAction<UserModel>) {
      state.loadingData = false;
      state.backOfficeProfile = action.payload;
    },
    updateBackOfficeProfileError(state, action: PayloadAction<Array<FormErrorModel>>) {
      if (action.payload.find((error: FormErrorModel) => error.field === "email")) {
        state.profileFormErrors = action.payload;
      }

      state.loadingData = false;
    },

    loadRoleSuccess(state, action: PayloadAction<RoleBasicInfoModel>) {
      state.role = action.payload;
    },
  },
});

export default backOfficeProfilePageSlice;
